export default [{
  path: '/activeworks',
  name: 'activework',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/activeworks/index')
}]
